import { FunctionComponent } from 'react'
import { AuthorProps } from './types'
import { getUrlProps } from './utils'
import translate from '@i18n'
import styled from 'styled-components'
import NameWithUrl from './NameWithUrl'

type SingleAuthorProps = Omit<AuthorProps, 'image'>

const NameAndRoleContainer = styled.div`
  margin: 0;
`

const NameContainer = styled.div`
  font-family: ${({ theme }) => theme.fonts.sourceSansPro};
  font-size: 14px;
  line-height: 16px;
  font-weight: bold;
`

const Name = styled.span`
  font-family: ${({ theme }) => theme.fonts.sourceSansPro};
  font-size: 14px;
  line-height: 16px;
  font-weight: bold;
`

const Role = styled.span`
  font-family: ${({ theme }) => theme.fonts.sourceSansPro};
  font-size: 14px;
  line-height: 16px;
  font-weight: normal;
`

const SingleAuthor: FunctionComponent<SingleAuthorProps> = ({
  name,
  url,
  role,
  type,
}) => (
  <NameAndRoleContainer>
    {type === 'basic' ? (
      <Name>{name}</Name>
    ) : (
      <>
        <div>
          <NameContainer>
            {url ? (
              <>
                {translate('author.by')}{' '}
                <NameWithUrl urlProps={getUrlProps(url)} name={name} />
              </>
            ) : (
              <Name>{`${translate('author.by')} ${name}`}</Name>
            )}
          </NameContainer>
        </div>
        {role && <Role>{role}</Role>}
      </>
    )}
  </NameAndRoleContainer>
)

export default SingleAuthor
